import generateFilterForQuery from "./common/_tools";
import { DealPaymentsStatisticQuery } from "./common/stats_deals_payments.query";
import { DealProductsStatisticQuery } from "./common/stats_deals_products.query";

export class DealExportAsXLSXQuery {
  static build(query: any) {
    return {
      template: DealExportAsXLSXQuery.TEMPLATE,
      queries: {
        deals: DealExportAsXLSXQuery.buildDealsQuery(query),
        products: DealProductsStatisticQuery.build(query),
        payments: DealPaymentsStatisticQuery.build(query),
      },
      format: "xlsx",
    };
  }

  static TEMPLATE =
    '<!DOCTYPE html>\n  <table font=Verdana font-size=10 orientation="portrait" area="A:K" scale="45">\n  <tr><td></td></tr> \n  <tr height=30>\n    <td wrap border bold bgcolor=FF72BF44 width=32>Клиент</td>\n  <td wrap border bold bgcolor=FF72BF44 width=32>Комментарий в сделке</td>\n      <td wrap border bold bgcolor=FF72BF44 width=28>Адрес доставки</td>\n      <td wrap border bold bgcolor=FF72BF44 width=35>Комментарий к адресу</td>\n      <td wrap border bold bgcolor=FF72BF44 width=33>Наименование продукта</td>\n      <td wrap border bold bgcolor=FF72BF44 width=15>Тип тары</td>\n      <td wrap border bold bgcolor=FF72BF44 width=15>Количество ведер</td>\n      <td wrap border bold bgcolor=FF72BF44 width=15>Количество кг</td>\n      <td wrap border bold bgcolor=FF72BF44 width=15>Цена за кг, руб</td>\n      <td wrap border bold bgcolor=FF72BF44 width=16>Сумма к оплате, руб</td>\n      <td wrap border bold bgcolor=FF72BF44 width=15>Условия оплаты</td>\n      <td wrap border bold bgcolor=FF72BF44 width=30 align="center">Примечания</td>\n  </tr>\n  \n    {{#deals.documents}}\n      {{#not_return}}   \n        {{^first_address}}\n        <tr height="auto" bgcolor="{{color}}" colsColumns="3">\n        {{/first_address}}\n        {{#first_address}}\n        <tr height="auto" bgcolor="{{color}}" colsColumns="0">\n          {{#color}}\n              <td wrap border base bold rowspan="{{counts_address}}" bgcolor="{{color}}">{{client_name}}</td>\n  <td wrap border base bold rowspan="{{counts_address}}" bgcolor="{{color}}">{{deal_comment}}</td>\n          {{/color}}\n          {{^color}}\n              <td wrap border base rowspan="{{counts_address}}" bgcolor="{{color}}">{{client_name}}</td>\n              <td wrap border base bold rowspan="{{counts_address}}" bgcolor="{{color}}">{{deal_comment}}</td>\n          {{/color}}\n          <td wrap border base rowspan="{{counts_address}}" bgcolor="{{color}}">{{point_address}}</td>\n          <td wrap border bold base color="770000" rowspan="{{counts_address}}" bgcolor="{{color}}">{{point_comment}}</td>\n        {{/first_address}}\n  \n        {{#not_take}}\n        <td wrap border base priority>{{product_name}}</td>\n        <td wrap border>{{product_variant_name}}</td>\n        <td wrap border type=number align=center>{{b_quantity}}</td>\n        <td wrap border type=number align=center>{{weight}}</td>\n        <td wrap border type=number align=center>{{#special_price}}{{.}}{{/special_price}}{{^special_price}}{{../b_price}}{{/special_price}}</td>\n        <td wrap border type=number align=center>{{cost}}</td>\n        <td wrap border>{{payment_type_name}}</td>\n        <td wrap border bold base color="770000" align="center">{{notes}}</td>\n        {{/not_take}}\n        {{#take}}\n        <td colspan="8" wrap bgcolor="#CCCCCC" bold base color="770000" align="center">{{notes}}</td>\n        {{/take}}\n      </tr>\n      {{/not_return}}\n    {{/deals.documents}}\n  \n    <tr>\n      <td></td>\n      <td></td>\n      <td></td>\n      <td></td>\n      <td></td>\n      <td></td>\n      <td bold type=number align=center formula="=SUM(INDIRECT(ADDRESS(1,COLUMN())&amp;&quot;:&quot;&amp;ADDRESS(ROW()-1,COLUMN())))"></td>\n      <td bold type=number align=center formula="=SUM(INDIRECT(ADDRESS(1,COLUMN())&amp;&quot;:&quot;&amp;ADDRESS(ROW()-1,COLUMN())))"></td>\n      <td></td>\n      <td bold type=number align=center formula="=SUM(INDIRECT(ADDRESS(1,COLUMN())&amp;&quot;:&quot;&amp;ADDRESS(ROW()-1,COLUMN())))"></td>\n    </tr>\n    \n    <tr>\n      <td></td>\n    </tr>\n  \n    <tr>\n      <td></td>\n      <td></td>\n      <td></td>\n      <td colspan="4" wrap border bold bgcolor=FF72BF44>Продукты</td>\n    </tr>\n  \n  \n    <tr>\n      <td></td>\n      <td></td>\n      <td></td>\n      <td wrap border bold bgcolor=FF72BF44>Продукт</td>\n      <td wrap border bold bgcolor=FF72BF44>Тара</td>\n      <td wrap border bold bgcolor=FF72BF44>Всего, шт</td>\n      <td wrap border bold bgcolor=FF72BF44>Всего, кг</td>\n    </tr>\n  \n    {{#products.documents}}\n      {{#not_return}}\n      {{#containers}}\n        <tr height="auto">\n          <td></td>\n          <td></td>\n          <td></td>\n          <td border wrap base priority>{{product_name}}</td>\n          <td border>{{container_name}}</td>\n          <td border>{{container_count}}</td>\n          <td border>{{#floatComma}}{{container_weight}}{{/floatComma}}</td>\n        </tr>\n      {{/containers}}\n  \n      <tr>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td border></td>\n        <td border></td>\n        <td border bold>{{container_count_sum}}</td>\n        <td border bold>{{#floatComma}}{{container_weight_sum}}{{/floatComma}}</td>\n      </tr>\n  \n      <tr>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td border></td>\n        <td border></td>\n        <td border></td>\n        <td border></td>\n      </tr>\n      {{/not_return}}\n    {{/products.documents}}\n    {{#with_return}}\n    <tr><td></td></tr> \n    <tr><td></td></tr>\n  \n    <tr height=30>\n      <td wrap border bold bgcolor=FF72BF44>Клиент</td>\n      <td wrap border bold bgcolor=FF72BF44>Адрес доставки</td>\n      <td wrap border bold bgcolor=FF72BF44>Комментарий к адресу</td>\n      <td wrap border bold bgcolor=FF72BF44>Наименование продукта</td>\n      <td wrap border bold bgcolor=FF72BF44>Тип тары</td>\n      <td wrap border bold bgcolor=FF72BF44>Количество ведер</td>\n      <td wrap border bold bgcolor=FF72BF44>Количество кг</td>\n      <td wrap border bold bgcolor=FF72BF44>Цена за кг, руб</td>\n      <td wrap border bold bgcolor=FF72BF44>Сумма к оплате, руб</td>\n      <td wrap border bold bgcolor=FF72BF44>Условия оплаты</td>\n      <td wrap border bold bgcolor=FF72BF44 align="center">Примечания</td>\n    </tr>\n    \n    {{#deals.documents}}\n      {{#return}}   \n      <tr height="auto">\n        <td wrap border>{{client_name}}</td>\n        <td wrap border>{{point_address}}</td>\n        <td wrap border base bold color="770000">{{point_comment}}</td>\n        {{#not_take}}\n        <td wrap border base priority>{{product_name}}</td>\n        <td wrap border>{{product_variant_name}}</td>\n        <td wrap border type=number align=center>{{b_quantity}}</td>\n        <td wrap border type=number align=center>{{weight}}</td>\n        <td wrap border type=number align=center>{{#special_price}}{{.}}{{/special_price}}{{^special_price}}{{../b_price}}{{/special_price}}</td>\n        <td wrap border type=number align=center>{{cost}}</td>\n        <td wrap border>{{payment_type_name}}</td>\n        <td wrap border bold base color="770000" align="center">{{notes}}</td>\n        {{/not_take}}\n        {{#take}}\n        <td colspan="8" wrap bgcolor="#CCCCCC" bold base color="770000" align="center">{{notes}}</td>\n        {{/take}}\n      </tr>\n      {{/return}}\n    {{/deals.documents}}\n  \n    <tr>\n      <td></td>\n    </tr>\n    \n    <tr>\n      <td></td>\n      <td></td>\n      <td></td>\n      <td colspan="4" wrap bgcolor=EFEFEF>Возвраты</td>\n    </tr>\n    \n    <tr>\n      <td></td>\n      <td></td>\n      <td></td>\n      <td colspan="4" wrap border bold bgcolor=FF72BF44>Продукты</td>\n    </tr>\n  \n  \n    <tr>\n      <td></td>\n      <td></td>\n      <td></td>\n      <td wrap border bold bgcolor=FF72BF44>Продукт</td>\n      <td wrap border bold bgcolor=FF72BF44>Тара</td>\n      <td wrap border bold bgcolor=FF72BF44>Всего, шт</td>\n      <td wrap border bold bgcolor=FF72BF44>Всего, кг</td>\n    </tr>\n  \n    {{#products.documents}}\n      {{#return}}\n      {{#containers}}\n        <tr height="auto">\n          <td></td>\n          <td></td>\n          <td></td>\n          <td border base priority>{{product_name}}</td>\n          <td border>{{container_name}}</td>\n          <td border>{{container_count}}</td>\n          <td border>{{#floatComma}}{{container_weight}}{{/floatComma}}</td>\n        </tr>\n      {{/containers}}\n      {{/return}}\n    {{/products.documents}}\n    {{/with_return}}\n  </table>\n  ';

  static buildDealsQuery(query: any) {
    const filter = generateFilterForQuery(query);

    // Выгрузка только отмеченных заявок: при переданных dealId используем только их (как в export1C)
    const dealIds = Array.isArray(query.dealId)
      ? query.dealId
      : query.dealId
        ? [query.dealId]
        : [];
    if (dealIds.length > 0) {
      filter.length = 0;
      filter.push({ $in: ["deal.id", { $: dealIds }] });
    }

    filter.push({
      $or: [
        { $null: ["deal.return_type_id"] },
        { $in: ["deal.return_type_id", { $: ["d:deals_return_types:2"] }] },
      ],
    });

    return {
      columns: {
        id: "deal.id",
        take: { $eq: ["deal.type_id", { $: "d:deals_types:2" }] },
        not_take: {
          $not: [{ $eq: ["deal.type_id", { $: "d:deals_types:2" }] }],
        },
        return: { $eq: ["deal.type_id", { $: "d:deals_types:3" }] },
        not_return: {
          $not: [{ $eq: ["deal.type_id", { $: "d:deals_types:3" }] }],
        },
        client_name: "client.name",
        special_orders: "client.special_orders",
        type_id: "deal.type_id",
        deal_comment: "deal.deal_comment",
        manager_name: "manager.name",
        expected_delivery_date: "deal.expected_delivery_date",
        confirmed_at: "deal.confirmed_at",
        point_address: "point.address",
        point_comment: "point.comment",
        payment_type_name: "ptype.name",
        product_name: "p.name",
        product_variant_name: "pc.name",
        b_quantity: "dcp.container_quantity",
        weight: {
          $case: [
            ["pc.price_per_kg", "dcp.container_weight"],
            [
              {
                $: true,
              },
              {
                $mul: ["pc.weight", "dcp.container_quantity"],
              },
            ],
          ],
        },
        b_price: "pc.price",
        special_price: "personal_settings.container_price",
        cost: "dcp.container_price",
        notes: "dcp.notes",
        // color: 'delivery_zone_groups.color'
        color: {
          $case: [
            [
              { $in: ["client.type_id", { $: ["d:client_types:6"] }] },
              { $: "#CCCCCC" },
            ],
            [
              {
                $: true,
              },
              "client.color",
            ],
          ],
        },
        exported_to_1c: {
          $case: [
            [{ $eq: ["deal.exported_to_1c", { $: true }] }, { $: "Да" }],
            [{ $: true }, { $: "" }],
          ],
        },
      },
      columns_order: [
        "id",
        "client_name",
        "manager_name",
        "confirmed_at",
        "expected_delivery_date",
        "point_address",
        "product_name",
        "product_variant_name",
        "b_quantity",
        "b_price",
        "cost",
        "payment_type_name",
        "notes",
      ],
      column_names: {
        id: "Идентификатор сделки",
        client_name: "Клиент",
        manager_name: "Менеджер",
        confirmed_at: "Согласованно",
        expected_delivery_date: "Дата доставки",
        point_address: "Адрес доставки",
        product_name: "Вид",
        product_variant_name: "Тара",
        b_quantity: "Кол-во",
        b_price: "Цена за кг",
        cost: "Cумма",
        payment_type_name: "Усл. оплаты",
        notes: "Примечание",
        color: "Цвет",
        exported_to_1c: "Выгружено в 1С",
      },
      from: "s:deals",
      from_as: "deal",
      joins: [
        {
          join: "s:employees",
          type: "left",
          as: "manager",
          on: {
            $eq: ["manager.id", "deal.manager_id"],
          },
        },
        {
          join: "s:clients",
          type: "left",
          as: "client",
          on: {
            $eq: ["client.id", "deal.client_id"],
          },
        },
        {
          join: "s:payment_deferment_periods",
          type: "left",
          as: "pdp",
          on: {
            $eq: ["pdp.id", "client.payment_deferment_period_id"],
          },
        },
        {
          join: "s:payment_types",
          type: "left",
          as: "ptype",
          on: {
            $eq: ["deal.payment_type_id", "ptype.id"],
          },
        },
        {
          join: "s:delivery_points",
          type: "left",
          as: "point",
          on: {
            $eq: ["deal.delivery_point_id", "point.id"],
          },
        },
        {
          join: "s:cities",
          type: "left",
          as: "city",
          on: {
            $eq: ["point.city_id", "city.id"],
          },
        },
        {
          join: "s:warehouses",
          type: "left",
          as: "warehouse",
          on: {
            $eq: ["deal.delivery_warehouse_id", "warehouse.id"],
          },
        },
        {
          join: "s:deal_product_containers",
          type: "left",
          as: "dcp",
          on: {
            $eq: ["dcp.deal_id", "deal.id"],
          },
        },
        {
          join: "s:product_containers",
          type: "left",
          as: "pc",
          on: {
            $eq: ["pc.id", "dcp.product_container_id"],
          },
        },
        {
          join: "s:products",
          type: "left",
          as: "p",
          on: {
            $eq: ["p.id", "pc.product_id"],
          },
        },
        {
          join: "s:statuses",
          type: "left",
          as: "status",
          on: {
            $eq: ["deal.status_id", "status.id"],
          },
        },
        {
          join: "s:client_product_containers",
          type: "left",
          as: "personal_settings",
          on: {
            $and: [
              {
                $eq: ["personal_settings.product_container_id", "pc.id"],
              },
              {
                $eq: ["personal_settings.client_id", "client.id"],
              },
            ],
          },
        },
        {
          join: "s:delivery_points",
          type: "left",
          as: "delivery_points",
          on: {
            $eq: ["delivery_points.id", "deal.delivery_point_id"],
          },
        },
        {
          join: "s:delivery_points_delivery_zones",
          type: "left",
          as: "delivery_points_delivery_zones",
          on: {
            $eq: [
              "delivery_points_delivery_zones.delivery_point_id",
              "delivery_points.id",
            ],
          },
        },
        {
          join: "s:delivery_zones",
          type: "left",
          as: "delivery_zones",
          on: {
            $eq: [
              "delivery_zones.id",
              "delivery_points_delivery_zones.delivery_zone_id",
            ],
          },
        },
        {
          join: "s:delivery_zone_groups",
          type: "left",
          as: "delivery_zone_groups",
          on: {
            $eq: [
              "delivery_zone_groups.id",
              "delivery_zones.delivery_zone_group_id",
            ],
          },
        },
        {
          join: {
            columns: {
              deal_id: "dpc.deal_id",
              sapmle_count: { $count: "dpc.id" },
            },
            from: "s:deal_product_containers",
            from_as: "dpc",
            joins: [
              {
                join: "s:product_containers",
                type: "left",
                as: "pc",
                on: {
                  $eq: ["pc.id", "dpc.product_container_id"],
                },
              },
            ],
            groups: ["dpc.deal_id"],
            where: {
              $or: [
                { $eq: ["dpc.is_sample", { $: true }] },
                { $eq: ["pc.is_sample", { $: true }] },
              ],
            },
          },
          type: "left",
          as: "dpc_with_samples",
          on: { $eq: ["dpc_with_samples.deal_id", "deal.id"] },
        },
      ],
      order: [
        {
          $desc: ["client.id"],
        },
        {
          $desc: ["deal.type_id"],
        },
        {
          $desc: ["point.address"],
        },
      ],
      where: {
        $and: [
          {
            $or: [
              { $null: ["status.final"] },
              { $eq: ["status.final", { $: "success" }] },
            ],
          },
          ...filter,
        ],
      },
    };
  }
}
